import 'babel-polyfill'
import _ from "lodash";

import Vue from 'vue'
import App from './App.vue'
import { store } from './store';
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import 'public/style.css'
// Font Awesome-related initialization
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

export const globalStore = new Vue({
  data: {
    selectedPeriod: 0,
    periods: store.state.periods,
    defaultRowsPerPage: 100,
    rowsPerPageItems: [15,50,100, 500] 
  },
})

Vue.prototype.$globals = globalStore;


// Add the specific imported icons
library.add(faFacebook)
library.add(faTwitter)
library.add(faInstagram)
library.add(faLinkedin)
library.add(fas, fab)


// Enable the FontAwesomeIcon component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuetify, {
  theme: {
    primary: '#4CAF50',
    secondary: '#8BC34A',
    accent: '#8c9eff',
    error: '#b71c1c'
  }})

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js